import { CEREALES_MOVIMIENTO, nombresCereales } from '../../../config/cereales'
import { TABLE_REPORTE_ESTADO_POR_CEREAL_TRIGO,
  TABLE_REPORTE_ESTADO_POR_CEREAL_SOJA,
  TABLE_REPORTE_ESTADO_POR_CEREAL_MAIZ,
  TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADAFO,
  TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADACE,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETGC,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELESOJA,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSC,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCG,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCS,
  TABLE_REPORTE_ESTADO_POR_CEREAL_HARISOJA,
  TABLE_REPORTE_ESTADO_POR_CEREAL_BARRIDO,
  TABLE_TOTAL_ESTADO_POR_CEREAL
} from '../../../config/tables'
import { ReportePorCerealService } from '../../../models/ReportePorCereal/ReportePorCerealService'
import { ReportePorCerealUtils } from '../../../models/ReportePorCereal/ReportePorCerealUtils'
import { COLUMNS, COLUMNS_TO_PRINT, COLUMNS_TOTALES, COLUMNS_TOTALES_TO_PRINT } from './constantesTablaReportePorCereal'
import { pdfCustomToolbarGenerator } from '../../../models/tools/generarPdf'

export function fetchSectores () {
  return async dispatch => {
    const tabla = [
      TABLE_REPORTE_ESTADO_POR_CEREAL_TRIGO,
      TABLE_REPORTE_ESTADO_POR_CEREAL_SOJA,
      TABLE_REPORTE_ESTADO_POR_CEREAL_MAIZ,
      TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADAFO,
      TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADACE,
      TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETGC,
      TABLE_REPORTE_ESTADO_POR_CEREAL_PELESOJA,
      TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSC,
      TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCG,
      TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCS,
      TABLE_REPORTE_ESTADO_POR_CEREAL_HARISOJA,
      TABLE_REPORTE_ESTADO_POR_CEREAL_BARRIDO
    ]
    // for (let i = 0; i < CEREALES.length; i++) {
    //   tabla.push(`TABLE_REPORTE_ESTADO_POR_CEREAL_${CEREALES[i]}`)
    //   tablaTotales.push(`TABLE_TOTAL_ESTADO_POR_CEREAL_${CEREALES[i]}`)
    // }
    for (let i = 0; i < CEREALES_MOVIMIENTO.length; i++) {
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          isLoading: true
        },
        id: tabla[i]
      })
    }
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLE_TOTAL_ESTADO_POR_CEREAL
    })
    const parsedData = []
    const parsedDataTotales = []
    const dataTotal = []
    let metrosDeVacioTotal = 0
    let pesoNetoTotalBaseTrigo = 0
    let pesoNetoTotalBaseVigente = 0
    let pesoNetoBaseVigente = 0
    let espacioNetoTotal = 0
    let espacioTotalCamiones = 0
    for (let i = 0; i < CEREALES_MOVIMIENTO.length; i++) {
      console.log('cereal', CEREALES_MOVIMIENTO[i])
      const dataSilos = await ReportePorCerealService.getReporteDeCerealDetallado(CEREALES_MOVIMIENTO[i])
      console.log('data silos', dataSilos)
      const dataTotales = await ReportePorCerealService.getReporteDeCerealTotales(CEREALES_MOVIMIENTO[i])
      console.log('data totales', dataTotales)
      parsedDataTotales[i] = dataTotales
      if (dataTotales && dataTotales.filas) {
        dataTotales.filas.forEach((total) => {
          dataTotal.push(total)
          metrosDeVacioTotal += total.metrosDeVacioTotal
          pesoNetoTotalBaseTrigo += total.pesoNetoTotalBaseTrigo
          pesoNetoTotalBaseVigente += total.pesoNetoTotalBaseVigente
          pesoNetoBaseVigente += total.pesoNetoBaseVigente
          espacioNetoTotal += total.espacioNetoTotal
          espacioTotalCamiones += total.espacioTotalCamiones
        })
      }
      parsedData[i] = ReportePorCerealUtils.parseDataCombinada(dataSilos, dataTotales)
      console.log('data parseada', parsedData[i])
      console.log('totales parseada', parsedDataTotales[i])
      console.log('data total', dataTotal)
      // dispatch({
      //   type: 'UPDATE_MUITABLE',
      //   newState: {
      //     columns: COLUMNS_TOTALES,
      //     data: parsedDataTotales[i].filas,
      //     title: `Totales de ${nombresCereales[CEREALES_MOVIMIENTO[i]]}`,
      //     isLoading: false,
      //     extraOptions: {
      //       customToolbar: null,
      //       print: false,
      //       pagination: false,
      //       download: false,
      //       filter: false,
      //       search: false,
      //       viewColumns: false
      //     }
      //   },
      //   id: tablaTotales[i]
      // })
      const customToolbar = pdfCustomToolbarGenerator(
        `Reporte detallado de Estado por Cereal ${nombresCereales[CEREALES_MOVIMIENTO[i]]}`,
        parsedData[i],
        COLUMNS_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS,
          data: parsedData[i],
          title: `Reporte Detallado de ${nombresCereales[CEREALES_MOVIMIENTO[i]]}`,
          isLoading: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false
          }
        },
        id: tabla[i]
      })
    }
    dataTotal.push({
      cereal: 'Total',
      cerealVariedad: '',
      metrosDeVacioTotal,
      pesoNetoTotalBaseTrigo,
      pesoNetoTotalBaseVigente,
      pesoNetoBaseVigente,
      espacioNetoTotal,
      espacioTotalCamiones
    })
    const customToolbar = pdfCustomToolbarGenerator(
      `Totales de todos los cereales`,
      dataTotal,
      COLUMNS_TOTALES_TO_PRINT,
      'portrait')
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        columns: COLUMNS_TOTALES,
        data: dataTotal,
        title: `Totales de todos los cereales`,
        isLoading: false,
        extraOptions: {
          customToolbar,
          print: false,
          pagination: false,
          download: false,
          filter: false,
          search: false,
          viewColumns: false
        }
      },
      id: TABLE_TOTAL_ESTADO_POR_CEREAL
    })

    // for (let i = 0; i < CEREALES.length; i++) {
    //   const dataSilos = await ReportePorCerealService.getReporteDeCerealDetallado(CEREALES[i])
    //   const dataTotales = await ReportePorCerealService.getReporteDeCerealTotales(CEREALES[i])
    //   const parsedData = ReportePorCerealUtils.parseDataCombinada(dataSilos, dataTotales)
    //   dataTotal.push(...parsedData)
    // }

    // dispatch({
    //   type: 'UPDATE_MUITABLE',
    //   newState: {
    //     columns: COLUMNS,
    //     data: dataTotal,
    //     title: `Reporte Estado Por Cereal`,
    //     isLoading: false
    //   },
    //   id: TABLE_REPORTE_ESTADO_POR_CEREAL
    // })
  }
}
